import {
	IModel,
	IVIPUserBase,
	VIPUserBase,
} from "@/loader";

export const rolesList: any[] = [
	{
		value: "administrator",
		text: "Administrateur",
	},
	{
		value: "administrative",
		text: "Administratif",
	},
	{
		value: "supervisor",
		text: "Conducteur de travaux",
	},
	{
		value: "manager",
		text: "Manager",
	},
	{
		value: "observer",
		text: "Observateur",
	},
	{
		value: "subscriber",
		text: "Visiteur",
	}
];

export function roleLabel(role: string | null): string | null {
	return rolesList.find(r => r.value === role)?.text || null;
}

/**
 * User Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPUser extends IVIPUserBase {
	password?: string | null;
	confirmPassword?: string | null;
}

/**
 * User Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPUser extends VIPUserBase implements IVIPUser, IModel<IVIPUser> {
	public password: string | null = null;
	public confirmPassword: string | null = null;

	constructor (data: IVIPUser = {}) {
		super(data);
	}

	public load(data: IVIPUser) {
		super.load(data);
	}

	public update(data: IVIPUser) {
		super.update(data);
	}

	public get isManager(): boolean {
		return this.roles.includes("manager");
	}

	public get isAdministrative(): boolean {
		return this.roles.includes("administrative");
	}

	public get isSupervisor(): boolean {
		return this.roles.includes("supervisor");
	}

	public get isManagerOrAbove(): boolean {
		return this.isManager || this.isAdmin;
	}

	public get isAdministrativeOrAbove(): boolean {
		return this.isAdministrative || this.isManager || this.isAdmin;
	}

	public get isSupervisorOrAbove(): boolean {
		return this.isSupervisor || this.isManager || this.isAdmin;
	}
}
